import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Entrega',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Serviço de quarto',
      [RoomServiceLocationType.TableService]: 'Serviço de mesa',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Nome da campainha (opcional)',
    },
    company_name: {
      placeholder: 'Nome da empresa (opcional)',
    },
    customer_note: {
      placeholder: 'Instruções de entrega (opcional)',
    },
    order_instructions: {
      placeholder: 'Introduza instruções de encomenda...',
    },
  },
};
